<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="chapter-title">ACKNOWLEDGMENTS</h2>
<p class="body-text1"> </p>
<p class="body-text1"> </p>
<p class="body-text1"> </p>
<p class="body-text1">This book is the product of countless conversations exploring how we give shape to our research and writing. It represents our shared commitment to rethinking the dominant approach to using interviews in research and writing about African art and artists. We endeavor not only to examine the methods, instruments, and processes at the heart of knowledge production but also to take them a step further by experimenting with their possibilities. With this project, we aspire to spark dialogue about the overlaps between the methodological orientations at play in Africanist art studies and those relevant to other art historical fields and interdisciplinary platforms. The contributions brought together here articulate some new possible directions for these exchanges.</p>
<p class="indent">We are especially pleased to be part of the African Expressive Cultures series and owe a considerable debt of gratitude to Patrick McNaughton, the series’ general editor, and Dee Mortensen, senior sponsoring editor at Indiana University Press, for their comments, insights, and enthusiasm. Our thanks also to this project's anonymous reviewers for their feedback, and to Sarah Jacobi and the staff at Indiana University Press for seeing us smoothly through the publication process. It has been deeply rewarding to collaborate with each other, and we appreciate the perspectives our contributors have brought to this conversation. Finally, we express our gratitude to our families, friends, and colleagues who supported various dimensions of this project and created the context for its completion.</p>
<p class="right1">Joanna Grabski and Carol Magee</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?0d1a11a1